<template>
    <div class="homePage">
        <div v-if="step == 1 || step==undefined">
            <div class="title">基本信息</div>
            <div class="basic">
                <div style="display:flex; padding:73px 340px 37px 92px;justify-content:space-between">
                    <div>
                        账号名: {{ accout }}
                    </div>
                    <div>
                        手机号码: {{ num }}
                    </div>
                </div>
                <hr>
                <div style="  padding:37px 92px 37px 93px;">
                    类型: {{ type }}
                </div>
            </div>
            <div class="title">个人信息</div>
            <el-row style="background-color: rgb(252, 252, 252)">
                <el-col :span="24">
                    <el-form ref="form" :model="form" style="padding:37px 0px 37px 50px;" label-width="80px">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="姓名">
                                    <el-input style="width:44%" placeholder="请输入姓名" v-model="form.name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="性别">
                                    <el-radio-group v-model="form.resource">
                                        <el-radio label="男"></el-radio>
                                        <el-radio label="女"></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-col :span="12">
                            <el-form-item label="国籍">
                                <el-select v-model="form.country" placeholder="请选择国籍">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="证件类型">
                                <el-select v-model="form.idcard" placeholder="请选择证件类型">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="证件号码">
                                <el-input style="width:44%" placeholder="请输入证件号码" v-model="form.idnumber"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话">
                                <el-input style="width:44%" placeholder="请输入联系电话" v-model="form.phone"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="联系地址">
                                <el-input placeholder="请输入联系地址" style="width:74%" v-model="form.adress"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-col>
            </el-row>
            <div style="display:flex;width:190px;margin:auto;margin-top:30px;">
                <div class="cancel" @click="cancel">取消</div>
                <div class="next" @click="next">下一步</div>
            </div>
        </div>
        <div v-else>
            <Step2 @step="getstep"></Step2>
        </div>
    </div>
</template>

<script>
import Step2 from './single2.vue'
export default {
    components: { Step2 },
    data() {
        return {
            tab: 1,
            accout: '257364527@qq.com',
            num: 13688888888,
            type: '个人',
            form: {
                name: '',
                country: '',
                idcard: '',
                idnumer: '',
                phone: '',
                adress: '',
                sex: '男',
            },
            step: 1
        };
    },
    methods: {
        cancel() {

        },
        next() {
            this.step = 2
        },
        getstep(string) {
            this.step = string
            console.log(this.step)
        }
    },
    created() {
        this.getstep()
    },
};
</script>

<style lang="scss" scoped>
.homePage {
    text-align: start;
    color: black;
    width: 1200px;
    margin: auto;

    .title {
        padding-left: 15px;
        font-size: 20px;
        border-left: 2px solid rgb(37, 135, 125)
    }

    .basic {

        background-color: rgb(252, 252, 252)
    }

    .cancel,
    .next {
        width: 94px;
        height: 38px;
        margin-right: 5px;
        cursor: pointer;
        background-color: rgb(228, 228, 228);
        text-align: center;
        line-height: 38px;
        border-radius: 5px;
    }

    .next {
        color: white;
        background-color: rgb(37, 135, 125)
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Signup/single1.vue